import { UpsertItemResponse } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'
import type { OrderItemTracking } from '@src/type/order'

export type ReqBody = {
	itemNo: string
	trackingNo: string | null
	courierName?: string
}
export const upsertOrderItemTracking = async ({
	itemNo,
	trackingNo,
	courierName,
}: ReqBody): Promise<UpsertItemResponse<OrderItemTracking>> => {
	const form = {
		tracking_no: trackingNo,
		courier_name: courierName,
	}

	const response = await client.post<UpsertItemResponse<OrderItemTracking>>(
		`/orders/items/${itemNo}/tracking`,
		form,
	)

	return response.data
}
